import SignupField from './SignupField.component';

export default SignupField;
